import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=a2ff8380&"
import script from "./Bread.vue?vue&type=script&lang=ts&"
export * from "./Bread.vue?vue&type=script&lang=ts&"
import style0 from "./Bread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports